import { memo } from 'react'
import { Tag, Tags } from 'lucide-react'
import { useTrackRemoveAttachment } from '../../../../hooks/attachments-hooks'
import { useAttachmentStore } from '../../../../store'
import type { ChatAttachment } from '../../../../types'
import { PreviewableContext } from '../../input/context/previewable-context'
import { AttachmentStub } from '../attachment-stub'
import { scrollablePreviewClassName } from '../styles'

/** Every attached insight collapses into one pill, so removing it detaches the whole set. */
export const InsightAttachments = memo(
  ({ insights, canRemove }: { insights: ChatAttachment[]; canRemove?: boolean }) => {
    const { removeAttachment } = useAttachmentStore()
    const trackRemoveAttachment = useTrackRemoveAttachment()
    const onRemove = () => {
      for (const insight of insights) {
        removeAttachment(insight)
      }
      trackRemoveAttachment({ type: 'insight', trigger: 'Attachment Pill' })
    }

    const label = `${insights.length} Highlight${insights.length > 1 ? 's' : ''}`

    return (
      <PreviewableContext preview={<InsightPreview insights={insights} />}>
        <AttachmentStub
          label={label}
          icon={insights.length > 1 ? <Tags size={16} /> : <Tag size={16} />}
          onRemove={canRemove ? onRemove : undefined}
        />
      </PreviewableContext>
    )
  },
)
InsightAttachments.displayName = 'InsightAttachments'

const InsightPreview = memo(({ insights }: { insights: ChatAttachment[] }) => {
  return (
    <div className={scrollablePreviewClassName}>
      {insights.length} highlight{insights.length > 1 ? 's' : ''} attached
    </div>
  )
})
InsightPreview.displayName = 'InsightPreview'
